"use strict";

var prop = "_erd";

function initState(element) {
    element[prop] = {};
    return getState(element);
}

function getState(element) {
    return element[prop];
}

function cleanState(element) {
    delete element[prop];
}

module.exports = {
    initState: initState,
    getState: getState,
    cleanState: cleanState
};



//////////////////
// WEBPACK FOOTER
// ./~/element-resize-detector/src/state-handler.js
// module id = 1067
// module chunks = 0